import styled from 'styled-components'
import { ProductsSlider } from '@components/ProductsSlider/ProductsSlider'

export const Content = styled.div`
  display: none;

  @media screen and (min-width: 992px) {
    display: inline-block;
    max-width: 95%;
    margin: 0 auto;
    position: relative;
  }
`

export const StyledProductSlider = styled(ProductsSlider)`
  border-radius: 1rem;
`
